import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components'

import { menuItems } from './HeaderMenuItems.const'

export default function HeaderMenuItems({ isOpen }: { isOpen: boolean }): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <Fragment>
      {isOpen && (
        <nav className="absolute z-20 right-4 top-14 w-52">
          <div className="p-2 items-start rounded shadow-experimental bg-white">
            {menuItems.map((elem) => (
              <Link className="w-full text-black-light" key={elem.type} to={elem.href}>
                <span className="p-2 space-x-1.5 flex items-center rounded hover:bg-purple-light">
                  <ResponsiveImage alt={t(`subjects.${elem.type}`)} height={24} srcKey={elem.iconSrc} width={24} />
                  <span>{t(`subjects.${elem.type}`)}</span>
                </span>
              </Link>
            ))}
          </div>
        </nav>
      )}
    </Fragment>
  )
}
